/* eslint-disable @typescript-eslint/no-explicit-any */
declare const tippy: any;

declare global {
  interface Window {
    GlossaryHighlight: {
      highlightItems: (
        selector: string | null,
        element?: Element | Array<Element>,
        customOptions?: Record<string, unknown>
      ) => void;
    };
  }
}

const createTemplate = (content: string, showCloseButton: boolean, title?: string) => {
  const template_title = `<div class="tippy-content__title">${title}</div>`;
  const template_description = `<div class="tippy-content__description">${content}</div>`;
  const template_close = '<div class="tippy-content__close"></div>';

  return `${title ? template_title : ''}${template_description}${showCloseButton ? template_close : ''}`;
};

const getDynamicContent = (element: string) => {
  const el = document.getElementById(element);
  return el ? el.dataset.dynamiccontent : undefined;
};

export type SetTooltipProps = {
  content: string;
  element: string;
  optionsOverride?: Record<string, unknown>;
  showCloseButton?: boolean;
  title?: string;
};

export const setTooltip = ({
  content,
  element,
  optionsOverride,
  showCloseButton = true,
  title,
}: SetTooltipProps): void => {
  const template = createTemplate(content, showCloseButton, title);

  const onShowHandler = (instance: any) => {
    if (showCloseButton) {
      const closeButton = instance.popperChildren.content.querySelector('.tippy-content__close') as HTMLElement;

      closeButton.addEventListener('click', function () {
        instance.hide();
      });
    }

    const newContent = getDynamicContent(instance.reference.id);
    if (newContent) {
      instance.setContent(createTemplate(newContent, showCloseButton, title));
    }
  };

  const options = {
    content: template,
    onShow: onShowHandler,
    allowHTML: true,
    animation: 'scale',
    arrow: true,
    duration: 200,
    flipBehavior: ['right', 'top'],
    interactive: true,
    maxWidth: 300,
    placement: 'right',
    theme: 'glossary',
    trigger: 'click mouseenter',
    zIndex: 9999,
    appendTo: document.body,
    ...optionsOverride,
  };

  tippy(element, options);
};

export const glossaryHighlighter = (
  selector: string | null,
  element?: Element | Array<Element>,
  customOptions?: Record<string, unknown>
) => {
  window.GlossaryHighlight.highlightItems(selector, element, customOptions);
};
